<template>
    <div>        
      <v-dialog v-model="showKennelSearchDialog">
          <KennelList :useForSelection="true" :onRowSelected="onKennelSelected"/>
      </v-dialog>
        <div class="text-left">
          <v-row class="ma-0 pa-0">
              <v-col cols="8" class="ma-0 pa-0">
                  <v-text-field 
                      v-model="selectedKennelId"
                      :label="label ? label : 'Kennel ID'"
                      clearable
                      @click:clear="selectedKennelId = ''" 
                      :disabled="!isEditMode || hideSearch" />
              </v-col>
              <v-col class="ma-0 pa-0">
                <div class="text-center">
                  <v-btn class="mt-5 ml-1" icon small v-on:click="loadKennelInfo()" color="primary">
                    <v-icon> mdi-refresh </v-icon>
                  </v-btn>
                  <v-btn class="mt-5 ml-1" icon small v-on:click="showKennelSearchDialog = true" :disabled="!isEditMode || hideSearch" color="primary">
                    <v-icon> mdi-magnify </v-icon>                        
                  </v-btn> 
                </div>
              </v-col>
          </v-row>
          <div v-if="kennelInfo && kennelInfo.kennelId">
            <v-row class="ma-0 pa-0">
                  <v-col cols="12" class="ma-0 pa-0">
                    <span class="text--secondary caption">
                      <a :href="`/admin/kennels/${encodeURIComponent(kennelInfo.kennelId)}`" target="_blank">
                          {{ kennelInfo.kennelName }}
                      </a>                         
                    </span><br/>
                    
                      <span class="text--secondary caption">       
                        <span v-if="kennelInfo.isHallOfFame"></span>  
                          HOF: {{ kennelInfo.isHallOfFame ? $dateUtils.formatDate(kennelInfo.hallOfFameDate) : '-'  }} • 
                          HOFX: {{ kennelInfo.isHallOfFameExcellent ? $dateUtils.formatDate(kennelInfo.hallOfFameExcellentDate) : '-'  }} • 
                          SKE: {{ kennelInfo.isStockdogExcellent ? $dateUtils.formatDate(kennelInfo.stockdogExcellentDate) : '-'  }} 
                      </span>
                  </v-col>
            </v-row>
            <v-divider v-if="showOwners" />
            <AdminCoownersList v-if="showOwners" :owners="kennelInfo.owners" :ownershipType="kennelOwnershipType" :isEditMode="false"/>               
          </div>
          <div v-else>
          </div>             
      </div>
    </div>      
</template>
<script lang="ts">
import Vue from 'vue';
import KennelList from "../../views/Admin/Searches/KennelList.vue";
import AdminCoownersList, { OwnershipType } from "./AdminCoownersList.vue";

import kennelService from "@/services/admin/kennelService";

export default Vue.extend({
  name: 'AdminKennelSearchDialog',
  props: {
    kennelId: { type: String },
    initialKennelId: { type: String },
    isEditMode: { type: Boolean },
    hideSearch: { type: Boolean },
    showOwners: { type: Boolean },
    returnOwners: { type: Boolean },
    label: { type: String },
  },
  components: {
    AdminCoownersList,
    KennelList
  },
  data: function() {
      return {
        showKennelSearchDialog: false,
        kennelInfo: {} as any,
        selectedKennelId: this.$props.kennelId
      };
  },
  computed: {
    kennelOwnershipType: function() {
      return OwnershipType.Kennel;
    },
  },
  methods: { 
    onKennelSelected: function(kennel: any){
        this.showKennelSearchDialog = false;
        this.selectedKennelId = kennel?.kennelId?.trim();
        this.loadKennelInfo();
    },
    loadKennelInfo: function() {
        if(!this.selectedKennelId){
          this.kennelInfo = {};
          return;
        }
        
        this.$store.dispatch("changeLoaderStatus",true);
        kennelService.getKennelById(this.selectedKennelId).then((res: any) => {
          if(res){
            this.kennelInfo = res;
            if (this.returnOwners) this.$emit('update-owners', [...(this.kennelInfo.owners ?? [])]);
          } else {
            this.kennelInfo = {};
          }
        }).catch(() => {
          this.kennelInfo = {};
        })
        .finally(() => {
          this.$store.dispatch("changeLoaderStatus",false);
        });
    },
  },
  watch: {    
    kennelId: function(newVal, oldVal){
      if(newVal != oldVal)
        this.selectedKennelId = newVal;    
    },    
    initialKennelId: function(newVal, oldVal){
      if(newVal != oldVal) {
        this.loadKennelInfo(); 
      }   
    },
    selectedKennelId: function(newVal, oldVal){      
      this.$emit('update:kennelId', newVal);
    }
  }
});
</script>
